export default __webpack_public_path__ + "media/titles/title_5_locale_da-d27a0519.png";